// export const confidence_Level = [
//     { name: "0–20% (Very Low)" },
//     { name: "21–40% (Low)" },
//     { name: "41–60% (Moderate)" },
//     { name: "61–80% (High)" },
//     { name: "81–100% (Very High)" }
// ];

export const confidence_Level = [
    { name: "Low" },
    { name: "Average" },
    { name: "High" }
];

// export const voice_Pitch = [
//     { name: "Low-pitched, Authoritative" },
//     { name: "Low-pitched, Calm" },
//     { name: "Medium-pitched, Warm" },
//     { name: "Medium-pitched, Neutral" },
//     { name: "High-pitched, Energetic" },
//     { name: "High-pitched, Soft" },
// ];

export const voice_Pitch = [
    { name: "Low" },
    { name: "Average" },
    { name: "High" }
];

// export const call_Quality = [
//     { name: "Very Poor" }, 
//     { name: "Poor" }, 
//     { name: "Fair" }, 
//     { name: "Good" }, 
//     { name: "Excellent" }
// ];

export const call_Quality = [
    { name: "Poor" },
    { name: "Average" },
    { name: "Excellent" }
];